import { render } from "./Hometown.vue?vue&type=template&id=71d18050&scoped=true"
import script from "./Hometown.vue?vue&type=script&lang=js"
export * from "./Hometown.vue?vue&type=script&lang=js"

import "./Hometown.vue?vue&type=style&index=0&id=71d18050&scoped=true&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d18050"]])

export default __exports__